import * as Scrivito from 'scrivito';
import { ColumnWidgetAttributes, ColumnWidgetBackgroundColor, ColumnWidgetId } from './column-widget-definitions';
import { ValidationInfo } from '../../utils/type.utils';
import { Message, WidgetTitle } from '../../utils/translations';
import Thumbnail from '../../assets/thumbnails/layout-columns.svg';
import { spacingGroup } from '../../utils/scrivito/spacing-definitions';

Scrivito.provideEditingConfig(ColumnWidgetId, {
  title: WidgetTitle.COLUMN,
  thumbnail: Thumbnail,
  properties: [ColumnWidgetAttributes.ELEMENTS, ColumnWidgetAttributes.BACKGROUND_COLOR],
  propertiesGroups: [spacingGroup],
  attributes: {
    [ColumnWidgetAttributes.BACKGROUND_COLOR]: {
      values: [
        { value: ColumnWidgetBackgroundColor.NONE, title: 'Keinen' },
        { value: ColumnWidgetBackgroundColor.LEFT_GRAY, title: 'Links grau' },
        { value: ColumnWidgetBackgroundColor.RIGHT_GRAY, title: 'Rechts grau' },
        { value: ColumnWidgetBackgroundColor.GRAY, title: 'Grau' },
      ],
    },
  },
  validations: [
    [
      ColumnWidgetAttributes.ELEMENTS,
      (widgets: Array<Scrivito.Widget>): ValidationInfo => {
        if (widgets.length !== 2) {
          return {
            message: Message.COLUMN_LENGTH,
            severity: 'error',
          };
        }
        return undefined;
      },
    ],
  ],
});
